import { get } from 'lodash';
import { createSelector } from 'reselect';

const getNeighborhoodsData = state => get(state, 'neighborhoods.data');
export const getNeighborhoodsForRegion = createSelector(
  [getNeighborhoodsData, (s, i) => i],
  (neighborhoods = {}, id) => neighborhoods[id]
);
